module.exports = __webpack_public_path__ + "cfab25b2a937d42cb7b2074c161f48cf.svg";